import React from 'react';
import { getDomainConfig, CONTACT_INFO } from '../config';
import './LegalPage.css';

function ReturnPolicyPage() {
  const config = getDomainConfig();
  const hostname = window.location.hostname.replace('www.', '');
  const displayEmail = `info@${hostname}`;

  return (
    <div className="legal-page">
      <h1>Return & Refund Policy</h1>
      <p className="last-updated">Last Updated: February 2026</p>

      <div className="legal-content">
        <section>
          <h2>1. Overview</h2>
          <p>
            At {config.name}, operated by {CONTACT_INFO.businessName}, we want you to be completely
            satisfied with your purchase. This Return & Refund Policy outlines the conditions under
            which products may be returned and refunds issued.
          </p>
          <p>
            Since products on our platform are sourced from third-party suppliers and manufacturers,
            return and refund eligibility may vary depending on the specific supplier's policies.
            We will work with you and the supplier to resolve any issues.
          </p>
        </section>

        <section>
          <h2>2. Return Eligibility</h2>
          <p>Products may be eligible for return under the following conditions:</p>
          <ul>
            <li>The return request is made within <strong>30 days</strong> of delivery</li>
            <li>The product is unused and in its original packaging</li>
            <li>The product is in the same condition as when it was received</li>
            <li>You have the original receipt or proof of purchase</li>
          </ul>
          <p>The following items are generally not eligible for return:</p>
          <ul>
            <li>Custom-made or specially ordered products</li>
            <li>Products that have been installed, modified, or used</li>
            <li>Hazardous materials, chemicals, or flammable liquids</li>
            <li>Items marked as non-returnable at the time of sale</li>
          </ul>
        </section>

        <section>
          <h2>3. How to Initiate a Return</h2>
          <p>To initiate a return, please follow these steps:</p>
          <ol>
            <li>Contact our support team at {displayEmail} or call {CONTACT_INFO.phone}</li>
            <li>Provide your order number and reason for the return</li>
            <li>Our team will review your request and provide a Return Authorization (RA) number</li>
            <li>Ship the product back using the provided return instructions</li>
          </ol>
          <p>
            Please do not ship products back without first obtaining a Return Authorization number.
            Unauthorized returns may not be processed.
          </p>
        </section>

        <section>
          <h2>4. Refund Process</h2>
          <p>
            Once we receive and inspect your returned item, we will notify you of the status of your
            refund. If your return is approved:
          </p>
          <ul>
            <li>Refunds will be processed within <strong>5-10 business days</strong></li>
            <li>The refund will be applied to your original method of payment</li>
            <li>Original shipping charges are non-refundable unless the return is due to our error</li>
          </ul>
        </section>

        <section>
          <h2>5. Defective or Damaged Products</h2>
          <p>
            If you receive a defective or damaged product, please contact us immediately. We will
            arrange for a replacement or full refund at no additional cost to you. Please include
            photos of the damage or defect to expedite the process.
          </p>
          <p>
            For defective products covered under manufacturer warranty, we will coordinate with the
            manufacturer on your behalf to process warranty claims.
          </p>
        </section>

        <section>
          <h2>6. Exchanges</h2>
          <p>
            If you need to exchange a product for a different size, specification, or model, please
            contact our support team. Exchanges are subject to product availability and may require
            returning the original item first.
          </p>
        </section>

        <section>
          <h2>7. Return Shipping</h2>
          <p>
            The buyer is responsible for return shipping costs unless the return is due to a defective
            product, shipping error, or incorrect item being sent. We recommend using a trackable
            shipping method to ensure your return arrives safely.
          </p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            If you have questions about our Return & Refund Policy, please contact us:
          </p>
          <p><strong>{CONTACT_INFO.businessName}</strong></p>
          <p>Email: {displayEmail}</p>
          <p>Phone: {CONTACT_INFO.phone}</p>
          <p>Address: {CONTACT_INFO.address}, {CONTACT_INFO.city}, {CONTACT_INFO.state} {CONTACT_INFO.zip}</p>
        </section>
      </div>
    </div>
  );
}

export default ReturnPolicyPage;
